export class Quote {
  bid: number;
  ask: number;
  isin: string;
  time: string;
  bidv: number;
  askv: number;
}
